import { Button, Tooltip } from "antd";
import { Translation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PendingCorrection } from "../../types/grading";
import { Pencil, Eye } from "lucide-react";
import { getKeycloakRealm } from "../helpers";

interface Props {
  correction: PendingCorrection;
}

export const PendingCorrectionActions = ({ correction }: Props) => {
  const navigate = useNavigate();

  const handleGrade = () => {
    navigate(`/${getKeycloakRealm}/exam-periods/correction/${correction.examInstanceId}`);
  };

  const isCompleted = correction.gradingStatus === 2; // Completed
  // Note: Lock status is handled by the table status column and API handles the lock check on start
  
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Tooltip title={<Translation>{(t) => isCompleted ? t("view") : t("grade")}</Translation>}>
        <Button 
          type={isCompleted ? "default" : "primary"} 
          shape="circle"
          icon={isCompleted ? <Eye size={16}/> : <Pencil size={16}/>} 
          onClick={handleGrade}
        />
      </Tooltip>
    </div>
  );
};
